import React from 'react';
import Image from 'next/image';

interface LoadingScreenProps {
  className?: string;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({ className = '' }) => {
  return (
    <div className={`fixed inset-0 bg-background z-50 flex items-center justify-center ${className}`}>
      <div className="flex flex-col items-center space-y-6">
        {/* 番茄钟图标动画 */}
        <div className="relative">
          <Image src={`/loading_logo.png`} alt={""} width={128} height={128} />
          {/* 旋转环 */}
          <div className="absolute inset-0 w-32 h-32 border-4 border-transparent border-t-red-300 rounded-full animate-spin"></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
